<template>
<transition name="fade">
    <div>
        <!-- Please provide your password again to complete this operation -->
        <h4>{{ $t("messages.login.repeatPassword") }}</h4>
        
        <!-- <div class="form-group">
            <b-form-input type="text" v-bind:placeholder="$t('messages.login.placeholder.email')" v-model="form.email"></b-form-input>
        </div> -->
        <div class="form-group">
            <b-form-input type="password" v-bind:placeholder="$t('messages.login.placeholder.password')" v-model="form.password"></b-form-input>
        </div>
        <button class="button mtop20"  v-on:click="onLogin">{{ $t("messages.login.enter") }}</button>
    </div>
</transition>

</template>

<script>
export default {
    name: 'LoginBox',
    props: {
        
    },
    data() {
        return {
            form:{
                email: null, 
                password: null
            }
        }
    },
    methods:{
       onLogin(){
            this.$emit('onLogin', this.form);
       },
       onCancel(){
            this.$emit('onCancel');
       }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/LoginBox.vue